import { Slot } from "expo-router";

import { MainLayout } from "~/component/layout";

const Layout = () => {
  return (
    <MainLayout hideFooter={true}>
      <Slot />
    </MainLayout>
  );
};

export default Layout;
